/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { usePlayer } from '../../../PlayerContext';

const rule = ({ isLive }) => ({
  cursor: isLive ? 'default' : 'pointer',
});

function LiveDot({ isLive }) {
  return isLive ? (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.99993" cy="6.99993" r="4.10345" fill="#A50605">
        <animate
          attributeType="XML"
          attributeName="fill"
          values="#300;#f00;#900;#300"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="7" cy="7" r="6" stroke="#E80C0B" strokeWidth="2" />
    </svg>
  ) : (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.99993" cy="6.99993" r="4.10345" fill="#666666" />
    </svg>
  );
}

LiveDot.propTypes = {
  isLive: PropTypes.bool,
};

function LiveLabel({ isLive, timeUntilLive }) {
  const { css } = useFela({ isLive });
  const player = usePlayer();

  const seekToLive = () => {
    if (isLive || !player) {
      return;
    }
    player.fastForward(timeUntilLive - 5);
  };

  return (
    <div className={css(rule)} onClick={seekToLive}>
      <LiveDot isLive={isLive} />
      <svg width="50" height="14" viewBox="0 0 39 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.11057 2.73425e-10H36.3871C36.7815 1.6789e-05 37.1707 0.0890186 37.5257 0.260334C37.8807 0.431649 38.1921 0.680833 38.4367 0.989207C38.6813 1.29758 38.8527 1.65715 38.9381 2.04095C39.0234 2.42475 39.0205 2.82283 38.9296 3.20535L36.9584 11.495C36.7888 12.2082 36.3827 12.8435 35.8059 13.2981C35.2291 13.7527 34.5153 14 33.7799 14H0L2.61042 2.77265C2.79375 1.98429 3.23955 1.28106 3.87515 0.777561C4.51076 0.274065 5.2987 -9.99582e-06 6.11057 2.73424e-10V2.73425e-10Z" fill={!isLive ? '#666666' : '#E80C0B'} />
        <path d="M13.5306 9.90771L13.2974 11.0697H8.16602L9.9125 2.93018H11.2037L9.69627 9.90771H13.5306V9.90771ZM15.6693 11.0697H14.3785L16.125 2.93018H17.4161L15.6697 11.0697H15.6693ZM20.8973 11.0697H19.5036L18.3147 2.93018H19.6117L20.4763 9.47339H20.5047L24.1287 2.93018H25.5623L20.8973 11.0697ZM30.1645 9.91911L29.9368 11.0697H24.7147L26.4611 2.93018H31.6833L31.4445 4.08078H27.5188L27.0069 6.38232H30.7217L30.494 7.4766H26.7852L26.2449 9.91911H30.1645V9.91911Z" fill="white" />
      </svg>
    </div>
  );
}

LiveLabel.propTypes = {
  isLive: PropTypes.bool,
  timeUntilLive: PropTypes.number,
};

export default React.memo(LiveLabel);
